import { observeElement } from '@uvocore-front/utils';
import './style.scss';

function Inc(obj) {
  const { elem } = obj;
  const input = elem.nodeName.toLowerCase() === 'input';
  let value = parseFloat(elem.getAttribute('data-inc-value')) || 0;
  let duration = parseInt(elem.getAttribute('data-inc-duration'), 10) || 0;
  let delay = parseInt(elem.getAttribute('data-inc-delay'), 10) || 0;
  const decimal = (obj.decimal > 2 ? 2 : obj.decimal) || 0;
  const currency = obj.currency || '';
  const speed = (obj.speed < 30 ? 30 : obj.speed) || 30;
  let count = 0;
  let increment = value / (duration / speed);
  let interval = null;
  const regex = /\B(?=(\d{3})+(?!\d))/g;
  const run = () => {
    count += increment;
    if (count < value) {
      if (input) {
        elem.value =
          currency +
          count
            .toFixed(decimal)
            .toString()
            .replace(regex, ',');
      } else {
        elem.innerHTML =
          currency +
          count
            .toFixed(decimal)
            .toString()
            .replace(regex, ',');
      }
    } else {
      clearInterval(interval);

      if (input) {
        elem.value =
          currency +
          value
            .toFixed(decimal)
            .toString()
            .replace(regex, ',');
      } else {
        elem.innerHTML =
          currency +
          value
            .toFixed(decimal)
            .toString()
            .replace(regex, ',');
      }
    }
  };
  setTimeout(() => {
    interval = setInterval(run.bind(this), speed);
  }, delay);

  this.reset = () => {
    clearInterval(interval);
    value = parseFloat(elem.getAttribute('data-inc-value')) || 0;
    duration = parseInt(elem.getAttribute('data-inc-duration'), 10) || 0;
    increment = value / (duration / speed);
    delay = parseInt(elem.getAttribute('data-inc-delay'), 10) || 0;
    count = 0;
    interval = setInterval(run, speed);
  };
} // Inc

function animateStatBlock(block, decimal) {
  const value = block.querySelector('.statistic-section__list__item-value');

  /* eslint-disable */
  new Inc({
    elem: value,
    speed: 50,
    decimal,
  });
  /* eslint-enable */
}

if (document.querySelector('.statistic-section')) {
  observeElement({
    element: '.statistic-section',
    marginValue: 0,
    threshold: 1,
    callback: () => {
      const animateBlocks = document.querySelectorAll(
        '.statistic-section__list .statistic-section__list__item',
      );
      animateStatBlock(animateBlocks[0], 1);
      animateStatBlock(animateBlocks[1], 2);
      animateStatBlock(animateBlocks[2], 0);
    },
  });
}
